import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';

import { QUERY_KEYS } from 'consts/queryKeys';
import { useCustomToast } from 'hooks';
import { updateNotificationSettingsRepresentative } from 'modules/settings/api';

export const useMutationUpdateNotificationSettingsRepresentative = () => {
  const queryClient = useQueryClient();

  const { errorToast } = useCustomToast();

  return useMutation(updateNotificationSettingsRepresentative, {
    onSuccess: () => {
      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_NOTIFICATION_TYPES);
      queryClient.refetchQueries(QUERY_KEYS.SETTINGS_NOTIFICATION_PERMITS);
    },
    onError: (error: AxiosError) => {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      errorToast(error?.response?.data?.ErrorDescription);
    },
  });
};
